module.exports = __webpack_public_path__ + "img/LTC-ability-07.ac273953.png";